import { render, staticRenderFns } from "./node-sign.vue?vue&type=template&id=45f55578&scoped=true&"
import script from "./node-sign.vue?vue&type=script&lang=js&"
export * from "./node-sign.vue?vue&type=script&lang=js&"
import style0 from "./node-sign.vue?vue&type=style&index=0&id=45f55578&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f55578",
  null
  
)

export default component.exports